<template>
  <article class="results-list__item results-list__item--business" data-id="results-list-item">
    <div class="business-item">
      <div class="business-item__outcome-wrapper">
        <div class="business-item__outcome" :class="outcomeClass">
          <div class="business-item__outcome-text u-primary-title u-type-16" v-if="item.outcome_friendly">
            {{ item.outcome_friendly[0] }}
            <span class="visuallyhidden">({{ item.outcome_category }})</span>
          </div>
        </div>
      </div>
      <div class="business-item__content">
        <span class="results-list__tophat u-secondary-dark"  v-if="item.business_item_type_friendly">{{ item.business_item_type_friendly[0] }}</span>
        <h3 class="business-item__title u-medium-title u-sans-serif u-sans-serif-title u-type-28 u-type-until-bp-small-24">
          <a :href="href" class="u-primary-very-dark u-hover-tertiary-dark">
            {{ item.title }}
          </a>
        </h3>
        <p class="business-item__description u-sans-serif u-type-16" v-html="proposedAdoptedText"></p>
      </div><!--/.business-item__content-->
    </div><!--/.business-item-->
  </article>
</template>

<script>

export default {
  name: 'ResultsListBusinessItemItem',
  props: ['item'],
  data() {
    return {
    }
  },
  computed: {
    href () {
      return this.item.path
    },
    title () {
      return this.item.title
    },
    outcomeClass () {
      if (this.item.outcome_category === 'Advancing') {
        return 'business-item__outcome--good u-bg-secondary-light';
      }
      if (this.item.outcome_friendly[0] === 'Awaiting Debate' && this.item.print_motion === '0') {
        // Special case. outcome_category should be 'Declined' but we want the
        // neutral color.
        return 'business-item__outcome--neutral u-bg-primary-light';
      }
      if (this.item.outcome_category === 'Declined') {
        return 'business-item__outcome--bad u-bg-tertiary-very-dark';
      }

      return 'business-item__outcome--neutral u-bg-primary-light';
    },
    proposedAdoptedText() {
      if (this.item.outcome_category === 'Declined') {
        if (this.item.outcome_friendly[0] === 'Defeated') {
          return 'This ' + this.item.business_item_type_friendly[0] + ' has been defeated.'
        }

        else if (this.item.outcome_friendly[0] === 'Object to Consideration') {
          return 'This ' + this.item.business_item_type_friendly[0] + ' has been objected to.'
        }

        else if (this.item.outcome_friendly[0] === 'Ruled Out of Order') {
          return 'This ' + this.item.business_item_type_friendly[0] + ' has been ruled out of order.'
        }

        else if (this.item.outcome_friendly[0] === 'Withdrawn') {
          return 'This ' + this.item.business_item_type_friendly[0] + ' has been withdrawn.'
        }
        else {
          return 'Language forthcoming.'
        }
      }

      if (this.item.has_consolidated === 1) {
        if (this.item.outcome_friendly[0] === 'Consolidated') {
          return this.truncateText(25, this.item.consolidated_text);
        }

        return this.truncateText(25,this.item.consolidated_text + this.item.proposed_adopted_text)
      }

      return this.truncateText(25, this.item.proposed_adopted_text)
    }
  },
  methods: {
    isTruncatable(length, data) {
      return data?.split(' ').length > (length - 1) || false
    },
    truncateText(length, data) {
      if (this.isTruncatable(length, data)) {
        return `${data.split(' ').slice(0, (length - 1)).join(' ')}...`
      }
      return data;
    },
  }
}
</script>
